module.exports = __webpack_public_path__ + "img/sello-socio.1124a410.png";